import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IconspriteService } from '../../services/iconsprite.service';

@Component({
    selector: 'u4-cpp-iconsprite',
    templateUrl: './iconsprite.component.html'
})
export class IconspriteComponent implements OnInit {

    public content: Observable<SafeHtml>;

    constructor(
        private iconspriteService: IconspriteService,
        private domSanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        this.content = this.iconspriteService.getIconSprite().pipe(
            map((response: string) => (this.domSanitizer.bypassSecurityTrustHtml(response) as Observable<SafeHtml>))
        );
    }
}
